export default __webpack_public_path__ + "static/media/cityEn.87c4fdd5.png";